import { Components } from '@mui/material';
import palette from './palette';

declare module '@mui/material/Checkbox' {
  interface CheckboxPropsColorOverrides {
    link: true;
    primaryStrong: true;
  }
}

const components: Components = {
  MuiCssBaseline: {
    styleOverrides: {
      '@global': {
        body: {
          backgroundColor: 'transparent',
        },
      },
    },
  },
  MuiTypography: {
    defaultProps: {
      variant: 'medium',
      variantMapping: {
        huge: 'h1',
        xxl: 'h2',
        xl: 'h3',
        large: 'p',
        medium: 'p',
        small: 'p',
        xs: 'p',
        micro: 'small',
      },
    },
  },
  MuiCircularProgress: {
    styleOverrides: {
      root: {
        color: palette.primary.dark,
      },
    },
  },
  MuiLinearProgress: {
    styleOverrides: {
      root: {
        width: '100%',
      },
    },
  },
  MuiTextField: {
    defaultProps: {
      variant: 'outlined',
    },
    styleOverrides: {
      root: {
        width: '100%',
        '& .MuiOutlinedInput-root': {
          color: palette.text.primary,
          fontSize: 16,
          borderRadius: '4px',
        },
        '& .MuiInputBase-multiline': {
          height: 'initial',
        },
        '& .MuiInputLabel-root': {
          color: palette.grey[700],
          fontSize: 16,
        },
        '& .MuiFormHelperText-root': {
          fontWeight: 400,
          lineHeight: '16px',
          marginTop: '4px',
          marginLeft: 0,
          marginRight: 0,
          fontSize: '10px',
          '&.Mui-error': {
            fontWeight: 700,
          },
        },
        '& legend': {
          fontSize: '0.72em',
        },
      },
    },
  },
  MuiSelect: {
    styleOverrides: {
      root: {
        '& .MuiSelect-select': {
          py: '10px',
          px: '14px',
        },
      },
    },
  },
  MuiCheckbox: {
    defaultProps: {
      color: 'primaryStrong',
    },
  },
  MuiLink: {
    styleOverrides: {
      root: {
        color: palette.link.main,
      },
    },
  },
};

export default components;
